import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputBooleanErrorMessage = (
  <Trans>
    Ce champ doit être vrai ou faux
  </Trans>
);
